/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

   document.addEventListener('DOMContentLoaded', function() {

    // Stops megamenu from disappearing immediately the second the mouse leaves the container
    customElements.whenDefined('hover-disclosure').then(() => {
      const HoverDisclosure = customElements.get('hover-disclosure');
      const proto = HoverDisclosure.prototype;
      const originalHide = proto.hideDisclosure;
      const originalShow = proto.showDisclosure;

      proto.hideDisclosure = function () {
        clearTimeout(this._hideTimer);
        this._hideTimer = setTimeout(() => {
          originalHide.call(this);
        }, 200);
      };

      proto.showDisclosure = function (e) {
        // Cancel any pending hide when we re-enter
        clearTimeout(this._hideTimer);
        originalShow.call(this, e);
      };
    });
    
    // Stops sibling image from disappearing immediately the second the mouse leaves the swatch
    customElements.whenDefined('product-siblings').then(() => {
      const ProductSiblings = customElements.get('product-siblings');
      const proto = ProductSiblings.prototype;
      const originalHide = proto.hideSiblings;

      proto.hideSiblings = function(e) {
        // Only hide if mouse has truly left the product item
        const productItem = this.closest('[data-grid-item]');
        if (productItem && e?.relatedTarget && productItem.contains(e.relatedTarget)) return;
        originalHide.call(this, e);
      };
    });

    // --- Product gallery slider scrollbar ---
      const slider = document.querySelector('.product__slides');
      if (slider) {
        const track = document.createElement('div');
        const thumb = document.createElement('div');

        track.className = 'product-scrollbar-track';
        thumb.className = 'product-scrollbar-thumb';

        track.style.cssText = 'position:absolute;bottom:0;left:0;width:100%;height:1px;background:#e0e0e0;z-index:10;pointer-events:none;';
        thumb.style.cssText = 'position:absolute;bottom:0;left:0;height:1px;background:#000;z-index:11;pointer-events:none;transition:width 0.1s;';

        const parent = slider.parentElement;
        parent.style.position = 'relative';

        parent.appendChild(track);
        parent.appendChild(thumb);


        function updateThumb() {
          const ratio = slider.clientWidth / slider.scrollWidth;
          const thumbWidth = slider.clientWidth * ratio;
          const thumbLeft = (slider.scrollLeft / slider.scrollWidth) * slider.clientWidth;
          thumb.style.width = thumbWidth + 'px';
          thumb.style.left = thumbLeft + 'px';
        }

       
        updateThumb();
        slider.addEventListener('scroll', updateThumb);
        window.addEventListener('resize', updateThumb);

        window.addEventListener('load', function() {
          setTimeout(function() {
            slider.scrollLeft = 0;
            updateThumb();
          }, 100);
        });

        // Lightbox
        const lightbox = document.createElement('div');
        lightbox.id = 'custom-lightbox';
        lightbox.innerHTML = `
          <button id="custom-lightbox__close" aria-label="Close">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 24 24"><path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <img id="custom-lightbox__img" src="" alt="" />
        `;
        document.body.appendChild(lightbox);

        const lightboxImg = lightbox.querySelector('#custom-lightbox__img');

        slider.querySelectorAll('.product__slide').forEach(function(slide) {
          if (slide.dataset.type === 'video' || slide.classList.contains('media--video')) return;
  
          slide.addEventListener('click', function(e) {
            console.log('slide clicked');
            const img = slide.querySelector('img');
            if (!img) return;
            e.stopPropagation();
            lightboxImg.src = img.src.replace(/width=\d+/, 'width=2000');
            lightbox.classList.add('is-open');
            document.body.style.overflow = 'hidden';

            // Center the scroll position once the image has loaded
            lightboxImg.onload = function() {
              const scrollX = (lightboxImg.scrollWidth - lightbox.clientWidth) / 2;
              lightbox.scrollLeft = scrollX > 0 ? scrollX : 0;
            };
          }, true);
        });

        lightbox.addEventListener('click', function() {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }

      // --- Grid slider scrollbar ---
      setTimeout(function() {
        const MARGIN = 16;
        const GAP = 4;

        const sliders = document.querySelectorAll('[data-grid-slider]');
        sliders.forEach(function(slider) {
          const wrapper = document.createElement('div');
          wrapper.style.cssText = 'position:relative;';
          slider.parentNode.insertBefore(wrapper, slider);
          wrapper.appendChild(slider);

          const track = document.createElement('div');
          const thumb = document.createElement('div');

          track.className = 'product-scrollbar-track';
          thumb.className = 'product-scrollbar-thumb';

          track.style.cssText = `position:absolute;bottom:0;left:0px;right:0px;width:auto;height:1px;background:#e0e0e0;z-index:10;pointer-events:none;`;
          thumb.style.cssText = `position:absolute;bottom:0;left:0px;height:1px;background:#000;z-index:11;pointer-events:none;transition:width 0.1s;`;

          wrapper.appendChild(track);
          wrapper.appendChild(thumb);

          

          function updateThumb() {
            // const availableWidth = slider.clientWidth - MARGIN * 2;
            const ratio = slider.clientWidth / slider.scrollWidth;
            const thumbWidth = (GAP * 2) + (slider.clientWidth - MARGIN * 2) * ratio;
            const thumbLeft = (slider.scrollLeft / slider.scrollWidth) * (slider.clientWidth - MARGIN * 2);
      
            thumb.style.width = thumbWidth + 'px';
            thumb.style.left = thumbLeft + 'px';
          }

          updateThumb();
          slider.addEventListener('scroll', updateThumb);
          window.addEventListener('resize', updateThumb);
        });
      }, 2000);

    });

  const u_WrapElement = (elementToWrap, wrapperHTML) => {
    // Create a temporary div to parse the wrapperHTML string
    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = wrapperHTML;

    // Get the actual wrapper element (the outermost element in wrapperHTML)
    const wrapper = tempWrapper.firstChild;

    // Get the parent of the element to be wrapped
    const parent = elementToWrap.parentNode;

    // If there's a parent, insert the wrapper before the elementToWrap
    if (parent) {
      parent.insertBefore(wrapper, elementToWrap);
    }

    // Append the elementToWrap into the wrapper
    wrapper.appendChild(elementToWrap);

    return elementToWrap; // Return the original element for chaining-like behavior
  }  

  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductMedia', () => ({
      init() {
        this.PlayVideo();
      },
      PlayVideo() {
        const deferredPosters = document.querySelectorAll('.deferred-media__poster');
        
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const media = entry.target.closest('.deferred-media');
              if (!media) return;

              // Load the video if not already loaded
              const poster = media.querySelector('.deferred-media__poster');
              if (poster && !media.dataset.loaded) {
                media.dataset.loaded = true;
                poster.dispatchEvent(new Event('click', { bubbles: true }));

                // Wait for video to appear in DOM then play
                setTimeout(() => {
                  const video = media.querySelector('video');
                  if (video) {
                    video.muted = true;
                    video.loop = true;
                    video.playsInline = true;
                    video.play();
                  }
                }, 300);
              }
            }
          });
        }, {
          threshold: 0.5 // video is 50% visible before triggering
        });

        deferredPosters.forEach(poster => {
          observer.observe(poster);
        });
      }
      
    }));

    Alpine.data('QuickAddForm', () => ({
      variant_id: '',
      init() {
        this.InitSelf();
      },
      InitSelf() {
        this.variant_id = this.$el.dataset.initial_variant_id;
      },
      e_QuickAddSizeVariant(size_variant_id) {
        this.variant_id = size_variant_id;

        this.$nextTick(() => {
          let $form = this.$el.closest('form');
          if (!$form) {
            console.error('add form not found');
            return;
          }
          let $btn_add = $form.querySelector('[data-add-to-cart]');
          $btn_add.click();          
        });
      }
    }));

    Alpine.data('CartUpsells', () => ({
      swiper: null,
      init() {
        this.InitWatchers();
        this.InitSelf();
      },
      InitSelf() {
        this.InitSwiper();
      },
      InitWatchers() {
        document.addEventListener('theme:cart:change', (e) => {
          // close any open upsell quick add forms
          document.dispatchEvent(new CustomEvent('cart:upsell:close'));

          // reinitialize swiper
          this.swiper.destroy(true, true);

          // Rebuild the swiper wrapper, because theme event replaces the content
          if (!this.$el.querySelector('.swiper-wrapper')) {
            let $items = this.$el.querySelectorAll('.swiper-slide');
            this.$el.querySelector('.swiper-upsells').innerHTML = `<div class="swiper-wrapper">${Array.from($items).map(item => item.outerHTML).join('')}</div>`;
          }
          setTimeout(() => {
            this.$nextTick(this.InitSwiper.bind(this));
          }, 0);
        });
      },
      InitSwiper() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper-upsells'), {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          navigation: {
            nextEl: '.icon-nav-arrow-right',
            prevEl: '.icon-nav-arrow-left',
          },
        });
      }
    }));

    Alpine.data('CartUpsellQuickAdd', () => ({
      product: null,
      current_variant: null,
      flags: {
        show: false
      },
      init() {
        this.InitWatchers();
        this.InitSelf();
      },
      InitSelf() {
      },
      InitWatchers() {
        this.$watch('flags.show', () => {
          this.$el.classList.toggle('active', this.flags.show);
          this.$el.closest('.drawer--cart').classList.toggle('is-upsell-quickadd-open', this.flags.show);
        });
        document.addEventListener('cart:upsell:close', () => {
          this.flags.show = false;
        });
      },
      u_GetFeaturedImage() {
        let media = this.product.media[0];
        let src = `${media.src}?crop=center&height=360&width=240`;
        return src;
      },
      u_GetSrcSet(media) {
        if (!media) return '';
        let widths = [120, 180, 240, 300, 360];
        let srcset = `${widths.map(width => `${media.src}&width=${width} ${width}w`).join(',')}`;
        return srcset;
      },
      u_FormatMoney(value) {
        return window.theme.formatMoney(value, theme.moneyFormat);
      },
      e_UpdateVariant(variant_id) {
        this.current_variant = this.product.variants.find(variant => variant.id === variant_id);
      },
      e_ShowUpsell(e) {
        this.flags.show = true;
        this.product = e.detail.product;
        this.current_variant = this.product.variants.find(v => v.id == e.detail.current_variant_id);
      },
      e_CloseUpsell(e) {
        if (e.target.closest('.product-upsell__btn')) return;
        if (this.flags.show) {
          this.flags.show = false;
        }
      }
    }));
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
